import { render, staticRenderFns } from "./SearchAreaInfo.vue?vue&type=template&id=3bcf5be6&scoped=true&"
import script from "./SearchAreaInfo.vue?vue&type=script&lang=js&"
export * from "./SearchAreaInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchAreaInfo.vue?vue&type=style&index=0&id=3bcf5be6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf5be6",
  null
  
)

export default component.exports